export default {
  path: '/topic',
  title: '选题策划',
  icon: 'flash',
  hideSub: true,
  children: ((pre) => [
    { path: `${pre}/new`, title: '选题申报', icon: 'dot-circle-o' },
    { path: `${pre}/review`, title: '选题审核', icon: 'dot-circle-o' },
    //{ path: `${pre}/calendar`, title: '选题库', icon: 'dot-circle-o' },
    { path: `${pre}/calendar`, title: '选题日历', icon: 'dot-circle-o' },
    { path: `${pre}/library`, title: '选题库', icon: 'dot-circle-o' },
    { path: `${pre}/my`, title: '我的选题', icon: 'dot-circle-o' },
    // { path: `${pre}/topic-review`, title: '投稿管理', icon: 'dot-circle-o' },
    // { path: `${pre}topic-review`, title: '选题审核', icon: 'file-word-o' }
  ])('/topic')
}
